import styled from "styled-components";
import ResourcesBack from '../../assets/images/ResourcesBack.png';
import DarkAgentBackground from '../../assets/images/darkiagentbk.png';
import DarkAgentLogoImg from '../../assets/images/darkiagent.png';
import {SiteColors} from '../../config/site-colors';

export const Wrapper = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* background: black; */
    color: white;
    font-family: Arial, Helvetica, sans-serif;
    /* padding-top:300px; */
    text-align: center;

    @media screen and (max-width: 800px) {
        height: auto;
    }
`;
export const AgentBackground = styled.nav`
    width: 100%;
    height: 120vh;
    position: relative;
    overflow-x: hidden;
    overflow-y: hidden;
    @media screen and (max-width: 800px) {
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const AgentImg = styled.div`
    width: 100%;
    height: 120vh;
    position: absolute;
    background-image: url(${DarkAgentBackground});
    color: white;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    z-index: -1;
    @media screen and (max-width: 800px) {
        height: 100%;
    }
`;
export const HeaderMeta = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 5%;
    text-align: left;
    @media screen and (max-width: 800px) {
        position: relative;
        left: unset;
        top: unset;
        transform: none;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .meta-intro {
        font-size: 1.8vw;
        font-family: Arial, Helvetica, sans-serif;
        margin-bottom: 50px;
        @media screen and (max-width: 800px) {
            text-align: center;
            font-size: 28px;
            padding-inline: 25px;
        }

        br {
            display: none;
            @media screen and (max-width: 800px) {
                display: block;
            }
        }

        a {
            cursor: pointer;
            text-decoration: underline;
            color: ${SiteColors.green};
        }
    }

    .meta-logo-holder {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 330px;
        margin-bottom: 40px;

        img {
            margin-bottom: 10px;

            @media screen and (max-width: 800px) {
            }
        }

        span {
            font-size: 44px;
            font-weight: bold;
            display: block;
        }
    }

    .meta-body {
        font-weight: 100;
        font-size: 33px;
        text-align: left;
        font-family: "HelveticaLt", Arial, sans-serif;
        line-height: 150%;
        text-transform: uppercase;
        @media screen and (max-width: 800px) {
            font-size: 20px;
            padding-inline: 1%;
            box-sizing: border-box;
            margin-top: 2vh;
            text-align: center;
        }
    }
`;


export const HeaderLogoHolder = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 5%;
    top: 50%;
    transform: translateY(-50%);
    width: 330px;

    @media screen and (max-width: 800px) {
        top: 20%;
        width: 100%;
        left: 50%;
        transform: translateX(-50%);
    }

    img {
        margin-bottom: 10px;

        @media screen and (max-width: 800px) {
        }
    }

    span {
        font-size: 44px;
        font-weight: bold;
        display: block;
    }
`;


export const Btn = styled.a`
    text-decoration: none;
    border-radius: 6px;
    background-blend-mode: multiply;
    /* Drop Shadow Style */
    box-shadow: 2px 2px 15px 2px rgba(0, 0, 0, 0.20);
    color: var(--black, #000);
    text-align: center;
    font-weight: 400;
    width: ${props => props.width ?? '7vw'};
    padding: ${props => props.padding ?? '0.5%'};
    font-size: 1vw;
    background: white;
    color: #1F3B71;
    cursor: pointer;
    font-family: Helvetica;
    @media screen and (max-width: 800px) {
        width: auto;
        font-size: 14px;
        padding: 2%;
        padding-inline: 5%;
        margin-top: 6vh;
    }
`;

export const Head = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;
    font-family: HelveticaLt, Arial;

    img {
        margin-bottom: 60px;
    }

    h1 {
        font-family: inherit;
        text-transform: uppercase;
        margin-bottom: 60px;
        font-size: clamp(22px, 1.5vw, 35px);
    }

    a {
        width: 230px;
        color: black;
        padding: 5px 15px;
    }
`;

export const YT = styled.div`
    width: 60vw;
    height: auto;
    /* margin-bottom: 150px; */
    position: relative;

    &.video-playing {
        height: 500px;
    }

    @media screen and (max-width: 800px) {
        margin-bottom: 80px;
        width: 90vw
    }

    .bg-img {
        border-radius: 30px;
    }

    .video-thumbnail-wrapper {
        position: relative;
        display: inline-block; /* or block if you want full width */
        width: 100%;
    }

    .play-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        filter: drop-shadow(0px 0px 30px black);
        width: 150px;
        cursor: pointer;
        transition: all .2s ease-in;

        &:hover {
            transform: translate(-50%, -50%) scale(1.1);
        }

        /* @media screen and (max-width: 1200px) {
            top: 30%;
            transform: translate(-50%, -30%);
        }

        @media screen and (max-width: 800px) {
            top: 20%;
            transform: translate(-50%, -20%);
        } */
    }

    .iframe-holder {
        width: 100%;
        height: 100%;
    }
`;

export const DarkAgentFeatures = styled.div`
    width: 100%;
    background-color: black;
    padding-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .row {
        width: 90vw;
        margin-bottom: 100px;
        text-align: start;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        @media screen and (max-width: 800px) {
            flex-direction: column;
            align-items: center;
        }

        .title {
            font-size: 2.5rem;
            font-weight: bold;
        }

        .description {
            margin-top: 20px;
            font-size: 1.2rem;
            line-height: 30px;
            margin-bottom: 20px;
        }

        .img-sample1 {
            width: 350px;
            @media screen and (max-width: 1300px) {
                width: 70%;
            }
        }

        .img-sample2 {
            width: 400px;
            @media screen and (max-width: 1300px) {
                width: 90%;
            }
        }

        .img-sample3 {
            width: 500px;
            @media screen and (max-width: 1300px) {
                width: 99%;
            }
        }

        .img {
            width: 600px;
            float: right;
            @media screen and (max-width: 1300px) {
                float: unset;
                width: 100%;
                margin-top: 20px;
            }
            @media screen and (max-width: 800px) {
                float: unset;
                width: 100%;
                margin-top: 20px;
            }
        }

        .col {
            width: 50%;
            @media screen and (max-width: 800px) {
                width: 90vw;
            }

        }
    }
`;

export const DarkAgentServices = styled.div`
    width: 100%;
    background: var(--ocean-gradient, linear-gradient(90deg, rgba(214, 214, 214, 1) 0%, rgba(161, 161, 161, 1) 100%));
    color: black;
    font-family: "Helvetica", Arial, sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 800px) {

    }

    .title {
        font-size: 3rem;
        margin-bottom: 30px;
        font-weight: bold;
        @media screen and (max-width: 800px) {
            line-height: 60px;
        }
    }

    .description {
        font-size: 1.2rem;
        padding-right: 80px;
        line-height: 30px;
        @media screen and (max-width: 800px) {
            padding-right: unset;
        }
    }

    .row {
        width: 90vw;
        margin-top: 70px;
        display: flex;
        text-align: left;
        margin-bottom: 70px;
        @media screen and (max-width: 800px) {
            flex-direction: column;
            align-items: center;
            margin-bottom: 30px;
        }
    }

    .col {
        width: 50%;
        @media screen and (max-width: 800px) {
            width: 100%;
            margin-bottom:50px;
        }
    }
`;

export const DarkAgentMeetSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    width: 100vw;
    /* font-family: 'Helvetica Light'; */
    font-family: "HelveticaLt", Arial, sans-serif;
    background: var(--ocean-gradient, linear-gradient(90deg, rgba(214, 214, 214, 1) 0%, rgba(161, 161, 161, 1) 100%));
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-blend-mode: multiply;
    position: relative;

    .title {
        border-radius: 60px;
        margin: 70px 70px;
        width: 90vw;
        text-align: left;
        font-size: 21px;
        font-family: "Helvetica", Arial, sans-serif;
        color: black;
        text-align: justify;
        @media screen and (max-width: 800px) {
            padding: 20px 10px;
            text-align: left;
        }
    }

    .row {
        display: flex;
        justify-content: space-between;
        width: 90vw;
        padding-bottom: 70px;
        @media screen and (max-width: 800px) {
            flex-direction: column;
            align-items: center;
            padding-bottom: unset;
        }
    }
`

export const DarkAgentMeetForm = styled.div`
    background-color: white;
    border-radius: 20px;
    width: ${props => props.width ?? '25vw'};
    padding: ${props => props.padding ?? '30px'};
    height: fit-content;
    box-sizing: border-box;
    color: black;
    font-family: "Helvetica", Arial, sans-serif;
    display: flex;
    flex-direction: ${props => props.flexDirection ?? 'column'};
    justify-content: space-between;
    margin-bottom: 70px;

    @media screen and (max-width: 800px) {
        width: 90vw;
        flex-direction: column
    }

    .form-title {
        font-weight: 700;
        font-size: 50px;
        text-align: left;
    }

    .form-comment {
        text-align: left;
        margin-top: 20px;
        font-size: large;
    }

    .form-message {
        margin-top: 30px;
        text-align: left;
        font-size: 12px;
        color: #565656;
    }

    .form-button {
        color: white;
        background-color: #000000;
        padding: 10px;
        padding-inline: 40px;
        cursor: pointer;
        text-transform: capitalize;
        margin-top: 30px;
        width: fit-content;
        border-radius: 10px;
        font-size: small;
        margin-left: auto;
        font-weight: 600;
        margin-right: 0;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
        transition: box-shadow 0.3s ease;
        border: none;

        :hover {
            opacity: 0.7;
        }

        :active {
            opacity: 1;
        }
    }

    .form-error {
        margin-top: 20px;
        color: red;
        text-align: left;
    }
`;